<template>
  <v-row
      v-if="filterGroups.length > 0"
  >
    <v-col
        cols="12"
        class="d-flex align-center"
    >
      <label
          class="v-label"
      >
        <b>
          Filtre
        </b>
      </label>

      <v-spacer/>

      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-col>

    <v-col
        v-for="FilterGroup in filterGroups"
        :key="FilterGroup.id"
        cols="12"
    >
      <v-autocomplete
          :items="FilterGroup.filters"
          item-value="id"
          item-text="title"
          no-data-text="Žiadne výsledky"
          :loading="loading"
          :disabled="loading"
          :label="FilterGroup.title"
          v-bind="$attrs"
          v-on="$listeners"
      >
        <template
            v-slot:append-outer
        >
          <CreateFilter
              v-if="createButton"
              :icon="true"
              :small="true"
              :FilterGroup="FilterGroup"
              @init="init"
          />
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
  import FilterGroups from '@/services/filter-groups'

  import CreateFilter from '@/components/Filters/Create'

  export default {
    name: 'SuggestFilters',
    props: [
      'createButton'
    ],
    components: {
      CreateFilter
    },
    data() {
      return {
        loading: false,
        filterGroups: []
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {
        this.loading = true

        FilterGroups
          .suggest()
          .then((response) => {
            this.filterGroups = response.data.data.filterGroups
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
